import { openLink, openTelegramLink } from "@telegram-apps/sdk-react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import {
    IconSocialTelegram2Fill,
    IconSocialDiscardFill,
    IconSocialWebsiteFill,
    IconSocialWhitePaperFill,
    IconSocialXFill,
} from "~/components/Iconfont/social";

const CAPSULE_MAP = {
    website: {
        name: "coin_info_pop_resources_website",
        icon: IconSocialWebsiteFill,
    },
    whitePaper: {
        name: "coin_info_pop_resources_paper",
        icon: IconSocialWhitePaperFill,
    },
    discord: {
        name: "coin_info_pop_resources_discord",
        icon: IconSocialDiscardFill,
    },
    telegram: {
        name: "coin_info_pop_resources_tg",
        icon: IconSocialTelegram2Fill,
    },
    twitter: {
        name: "coin_info_pop_resources_x",
        icon: IconSocialXFill,
    },
} as const;

export default function KDetailCapsule({
    type,
    link = "",
}: {
    type: keyof typeof CAPSULE_MAP;
    link: string;
}) {
    const { t } = useTranslation();

    const item = CAPSULE_MAP[type];

    const clickEvent = () => {
        if (!link) return;
        if (type === "telegram") {
            openTelegramLink(link);
        } else {
            openLink(link);
        }
    };

    return (
        <Fragment>
            {item ? (
                <div
                    className="flex items-center pl-[6px] pr-[12px] border-[0.5px] border-border_2 rounded-[8px] w-fit h-[30px] mr-[8px] mb-[8px] cursor-pointer"
                    onClick={clickEvent}
                >
                    <item.icon className="text-[20px] text-text_3" />
                    <div className="text-body3 font-Regular text-text_1 ml-[6px] text-nowrap">
                        {t(item.name)}
                    </div>
                </div>
            ) : null}
        </Fragment>
    );
}
